import { PageHeader } from "@shared/components/PageHeader";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import TemplateDetails from "../templateDetails/templateDetails";
import { Card } from "@shared/ui/card";
import QuickAction from "../quickAction/quickAction";
import { Tabs } from "@shared/ui/tabs";
import UsageHistoryLanding from "../tabs/usageHistory/landing/landing";
import VersionHistory from "../tabs/versionHistory/versionHistory";

import { useGetTemplateData } from "../../hooks";
import ActivityLog from "@features/ax/assetRegistry/facilities/components/detail/tabs/activityLog/activityLog";
import { NotesTab } from "@features/ux/components/shared/components/notesTab";
import { ActivityLogTab } from "@features/ux/components/shared/components/activityLog";

const TemplateLanding = () => {
  const navigate = useNavigate(); 
const params = useParams();
const templateId = params.id;
  const {data:templateData}=useGetTemplateData(templateId)
  return (
    <div>
      <div className="flex items-center gap-4">
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700 hover:text-gray-900"
          onClick={() => navigate("/communication-hub/templates")}
        />
        <div className="flex flex-col">
          <PageHeader
            title="View Template"
            subtitle="Preview and verify your template content"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <Card className="col-span-8 mt-4">
          <TemplateDetails data={templateData} />
        </Card>
        <Card className="col-span-4 mt-4">
         <QuickAction templateData={templateData} />
        </Card>
      </div>
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="usageHistory"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-4 mb-6 p-1"
            urlMapping={{
              usageHistory: "usageHistory",
              versionHistory: "versionHistory",
              notes: "notes",
              activityLog: "activityLog",
            }}
            tabComponents={{
              usageHistory: {
                label: "Usage History",
                component: <UsageHistoryLanding />,
              },
              versionHistory: {
                label: "Version History",
                component: <VersionHistory />,
              },
              notes: {
                label: "Notes",
                component: (
                  <NotesTab
                    requestId={templateId}
                    source="1"
                  />
                ),
              },
              activityLog: {
                label: "Activity Log",
                component: <ActivityLogTab entityId={templateId} entityType="1" />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TemplateLanding;
